import * as requestFromServer from "./consolidation-export-crud";
import {
  superAdminConsolidationExportSlice,
  callTypes
} from "./consolidation-export-slice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminConsolidationExportSlice;

export const fetchConsolidationExports = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findConsolidationExport(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.consolidationExportsFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const exportConsolidation = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .exportConsolidation(payload)
    .then(response => {
      dispatch(actions.consolidationExportReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};
